import { EventEmitter } from '@angular/core';
import { Subject } from 'rxjs';

declare var bz: any;

export class OAuthClient {

    private _authenticationSubject: Subject<boolean> = null;
    private _locationWatcher: any = new EventEmitter();
    protected oauth: any = new bz.oAuthClient();
    protected token: string;
    protected loggedOn: boolean;
    protected type: string; // accounts | bizagi
    public refreshPromise: any;

    constructor(type: string) {
        this.type = type;
        this._authenticationSubject = new Subject<boolean>();
    }

    public login(params: any) {
        const that = this;

        // Add type
        params = params || {};
        params.type = this.type;

        return new Promise<void>((resolve, reject) => {
          that.oauth.initAndLogin(params).done(function () {
              that.token = that.oauth.getAccessToken();
              if (that.token){
                  that.loggedOn = true;
                  // Generates a notification for the readers of this subject
                  that._authenticationSubject.next(true);
              }
              resolve();
          }).fail(function () {
              reject();
          });
      });
    }

    public logout() {
        this.oauth.logout();
    }

    public getToken(): string {
        return this.token;
    }

    public isLoggedOn(): boolean {
        return this.loggedOn;
    }

    public getUserEmail(): string {
        const profile = this.oauth.getProfile();
        return profile ? profile.email : '';
    }

    public getUserProfile(): IUserProfile {
        const profile = this.oauth.getProfile()
        const user = {
            name: profile && profile.firstName ? profile.firstName : (profile.lastName ? profile.lastName : ''),
            email: profile.email
        };

        return user ;
    }

    public refreshToken(): any {
        /* TODO: Validar cuando es Accounts2 y llamar el refresh token */
        return this.oauth.refreshToken();
        /*
        this.token = this.oauth.getAccessToken();
        this._authenticationSubject.next(true);
        return this.token;*/
    }

    public getAccessToken(): string {
        return this.oauth.getAccessToken();
    }

    public isAuthenticatedAsync(): Subject<boolean> {
        return this._authenticationSubject;
    }

    public subscribe(onNext: (value: any) => void,
        onThrow?: (exception: any) => void, onReturn?: () => void): any {
        return this._locationWatcher.subscribe(onNext, onThrow, onReturn);
    }

    public getTokenInfo() {
        return this.extractIdToken(this.oauth.getIdToken());
    }

    private extractIdToken(encodedIdToken) {
        // id token will be decoded to get the username
        const decodedToken = this.decodeIdToken(encodedIdToken);
        if (!decodedToken) {
            return null;
        }
        try {
            const base64IdToken = decodedToken.JWSPayload;
            const base64Decoded = this.decodeFromBase64(base64IdToken);
            if (!base64Decoded) {
                console.error('The returned id_token could not be base64 url safe decoded.');
                return null;
            }
            // ECMA script has JSON built-in support
            return JSON.parse(base64Decoded);
        } catch (err) {
            console.error('The returned id_token could not be decoded: ' + err.stack);
        }
        return null;
    }

    private decodeIdToken(idToken) {
        const idTokenPartsRegex = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/;
        const matches = idTokenPartsRegex.exec(idToken);
        if (!matches || matches.length < 4) {
            console.log('The returned id_token is not parseable.');
            return null;
        }
        const crackedToken = {
            header: matches[1],
            JWSPayload: matches[2],
            JWSSig: matches[3]
        };
        return crackedToken;
    }

    private decodeFromBase64 = function (text) {
        // html5 should support atob function for decoding
        text = text.replace(/-/g, '+').replace(/_/g, '/');
        if (window.atob) {
            return decodeURIComponent(window.atob(text)); // jshint ignore:line
        }
        return null;
    }
}

// Bizagi oAuth client
export class BizagiOAuthClient extends OAuthClient {
    constructor() { super('bizagi') }
}

// Accounts oAuth client
export class AccountsOAuthClient extends OAuthClient {
    constructor() { super('accounts') }
}
